export const productShortName = 'HVAC & Refrigeration Systems — Professional Edition™';
export const productBrand = 'HVAC & Refrigeration Systems';
export const productEdition = 'Professional Edition™';
export const productImage = 'https://cdn.magicpatterns.com/uploads/jb5Afy9Q32VJzYya58RF1a/MOCKUP_HVAC.png';
export const productImageAlt =
  'HVAC & Refrigeration Systems Professional Edition: six volumes covering fundamentals, the refrigeration cycle, system components, air distribution, controls and field practice, plus five bonus resources';

export const checkoutUrl = 'https://hvac-refrigeration-systems.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more confusion about pressures, temperatures and superheat',
  'No more guessing which component is failing',
  'No more gaps in understanding airflow, controls and wiring',
  'No more improvising installation, charging and maintenance',
  'No more scattered notes and outdated manuals',
];
